import { useToastStore } from '@/stores/toast';
import { cn } from '@/lib/utils';
import { X, CheckCircle2, AlertCircle, AlertTriangle, Info } from 'lucide-react';

export function Toaster() {
  const { toasts, dismiss } = useToastStore();
  return (
    <div className="fixed bottom-4 right-4 z-[100] flex w-full max-w-sm flex-col gap-2">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={cn(
            'flex items-start gap-3 rounded-lg border bg-card p-4 shadow-lg',
            t.level === 'error' && 'border-destructive/50',
            t.level === 'success' && 'border-emerald-500/50',
            t.level === 'warning' && 'border-amber-500/50',
          )}
        >
          <div className="mt-0.5 shrink-0">
            {t.level === 'success' && <CheckCircle2 className="h-4 w-4 text-emerald-600" />}
            {t.level === 'error' && <AlertCircle className="h-4 w-4 text-destructive" />}
            {t.level === 'warning' && <AlertTriangle className="h-4 w-4 text-amber-600" />}
            {t.level === 'info' && <Info className="h-4 w-4 text-sky-600" />}
          </div>
          <div className="flex-1 text-sm">
            <div className="font-medium">{t.title}</div>
            {t.message && <div className="text-muted-foreground">{t.message}</div>}
          </div>
          <button
            onClick={() => dismiss(t.id)}
            className="rounded-md p-1 hover:bg-muted"
            aria-label="Dismiss"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      ))}
    </div>
  );
}
